import defaultBg from "@assets/images/bgs/bg.png";
import bg_register from "@assets/images/bgs/bg_register.png";
import bg_pascoa from "@assets/images/bgs/bg_pascoa.svg";
import bg_junino from "@assets/images/bgs/bg_junino.png";
import bg_natal from "@assets/images/bgs/bg_natal.png";
import bg_copa from "@assets/images/bgs/bg_copa.png";

const seasonalThemes = [
  { name: "pascoa", start: new Date("2026-03-05T00:00:00"), end: new Date("2026-04-15T23:59:59"), background: bg_pascoa },
  { name: "junina", start: new Date("2025-06-01T00:00:00"), end: new Date("2025-07-29T23:59:59"), background: bg_junino },
  { name: "natal", start: new Date("2025-11-30T00:00:00"), end: new Date("2026-01-15T23:59:59"), background: bg_natal },
  { name: "copa", start: new Date("2026-05-20T00:00:00"), end: new Date("2026-07-20T23:59:59"), background: bg_copa },
];

export const getAppBackground = (isRegister) => {
  if (isRegister) return bg_register;
  const now = new Date();
  const themeMatch = seasonalThemes.find(({ start, end }) => now >= start && now <= end);
  return themeMatch ? themeMatch.background : defaultBg;
};